module.exports = __webpack_public_path__ + "static/media/item_6_4_comp.59f5ae04.png";